import { AxiosResponse } from 'axios';
import { clientProvider } from '@/api/clients/axios';
import {
  IqCustByUserNumKeyRequestDTO,
  IQCustByPhoneNumberRequestDTO,
} from '@/api/dto/request/IqCustRequestDTO';
import IqCustResponseDTO from '@/api/dto/response/IqCustResponseDTO';
import Repository from './repository';
import AtCustResponseDTO from '@/api/dto/response/AtCustResponseDTO';
import {
  AtCustByUserNumKeyRequestDTO,
  AtCustByPhoneNumberRequestDTO,
  AtPreJoinByUserNumKeyRequestDTO,
} from '@/api/dto/request/AtCustRequestDTO';
import { AtPreJoinResponseDTO } from '@/api/dto/response/AtPreJoinResponseDTO';

class CustomerRepository extends Repository {
  [key: string]: Function;

  async NP_IQ_CUST(
    citygasCode: string,
    IqCustDTO: IqCustByUserNumKeyRequestDTO | IQCustByPhoneNumberRequestDTO,
  ): Promise<AxiosResponse<IqCustResponseDTO>> {
    return await this.post(citygasCode, '/naver/np_iq_cust', IqCustDTO);
  }

  async NP_AT_CUST(
    citygasCode: string,
    AtCustDTO: AtCustByUserNumKeyRequestDTO | AtCustByPhoneNumberRequestDTO,
  ): Promise<AxiosResponse<AtCustResponseDTO>> {
    return await this.post(citygasCode, '/naver/np_at_cust', AtCustDTO);
  }

  async NP_AT_PREJOIN(
    citygasCode: string,
    atPreJoinDTO: AtPreJoinByUserNumKeyRequestDTO,
  ): Promise<AxiosResponse<AtPreJoinResponseDTO>> {
    return await this.post(citygasCode, '/naver/np_at_prejoin', atPreJoinDTO);
  }

}

export const customerRepository = new CustomerRepository(clientProvider.getClient());
